// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U09Eky3CRmUPddTMafDc{width:109px}.s0hyMyLFxm8_jtbP2YFE{flex-direction:column;flex-grow:1;padding:0 16px;display:flex;position:relative}.bDUCfbutp8Yp71y5fGE0{justify-content:space-between;align-items:center;gap:10px;max-width:260px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guideButton": `U09Eky3CRmUPddTMafDc`,
	"wrap": `s0hyMyLFxm8_jtbP2YFE`,
	"nameCellWrapper": `bDUCfbutp8Yp71y5fGE0`
};
export default ___CSS_LOADER_EXPORT___;
